import React from 'react';

import {BaseBlock, ContentActions, ContentOptions} from '../types';
import {ELSE_STATEMENT} from './constants';
import StaticStatement from './StaticStatement';

interface ElseProps {
  content: BaseBlock;
  options?: ContentOptions;
  actions?: ContentActions;
}

export const Else_ = ({
  content,
  actions,
}: ElseProps) => {
  return <StaticStatement
    text={ELSE_STATEMENT}
    content={content}
    actions={actions}
  />
}

export default Else_;
